
import './App.css';
import AboutUs from './components/About/AboutUs';
import CryptoItem from './components/CryptoItem/CryptoItem';
import NavBar from './components/Navbar/NavBar';
import Pagination from './components/pagination/Pagination';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import ContatUs from './components/Contact/ContatUs';
import Register from './components/Auth/Register';
import Login from './components/Auth/Login';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Profile from './components/Profile/Profile';
import Favorites from './components/Favorites/Favorites';
import { useState} from 'react';

function App() {
  const [color, setColor] = useState('light');
  return (
    <div>
      
      <BrowserRouter>
      <ToastContainer/>
      
      <NavBar color={color} setColor={setColor}/>
      <Routes>
        <Route path='/' element={<Pagination itemsPerPage={10} color={color}/>}/>
        <Route path='/home' element={<Pagination itemsPerPage={10} color={color}/>}/>
        <Route path='/register' element={<Register/>}/>
        <Route path='/login' element={<Login/>}/>
        <Route path='/about' element={<AboutUs/>}/>
        <Route path='/contact' element={<ContatUs/>}/>
        <Route path='/coin/:id' element={<CryptoItem color={color}/>}/>
        <Route path='/profile' element={<Profile/>}/>
        <Route path='/fav' element={<Favorites color={color}/>  }/>
      </Routes>
          
      
      </BrowserRouter>
      {/* <Cryptochart/> */}
      
      

      
    </div>
  );
}

export default App;
